import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { Stagger, StaggerItem } from './motion';

export const Container = ({ className, children }) => (
  <div className={clsx('mx-auto w-full max-w-7xl px-5 sm:px-8', className)}>{children}</div>
);

export const Section = ({ id, className, children }) => (
  <section id={id} className={clsx('relative py-24 sm:py-32', className)}>
    {children}
  </section>
);

export const SectionHeader = ({ eyebrow, title, description, align = 'center', className }) => (
  <Stagger
    className={clsx(
      'max-w-3xl',
      align === 'center' ? 'mx-auto text-center' : 'text-left',
      className
    )}
  >
    {eyebrow && (
      <StaggerItem>
        <span className="eyebrow">{eyebrow}</span>
      </StaggerItem>
    )}
    <StaggerItem
      as="h2"
      className="text-gradient mt-6 text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl"
    >
      {title}
    </StaggerItem>
    {description && (
      <StaggerItem as="p" className="mt-6 text-lg leading-relaxed text-slate-400 sm:text-xl">
        {description}
      </StaggerItem>
    )}
  </Stagger>
);

export const Logo = ({ className }) => (
  <Link to="/#top" aria-label="Groupmoney home" className={clsx('inline-flex items-center', className)}>
    <span className="text-2xl font-bold tracking-tight">
      Group<span className="text-brand-400">money</span>
    </span>
  </Link>
);

const AVATAR_COLORS = {
  blue: 'from-blue-500 to-blue-700',
  green: 'from-emerald-400 to-emerald-600',
  amber: 'from-amber-400 to-orange-500',
  purple: 'from-violet-500 to-purple-700',
  pink: 'from-pink-500 to-rose-600',
  slate: 'from-slate-600 to-slate-700',
};

export const Avatar = ({ initials, color = 'blue', size = 'md', className }) => (
  <span
    className={clsx(
      'inline-flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br font-bold text-white ring-2 ring-ink-950',
      AVATAR_COLORS[color],
      size === 'sm' && 'h-8 w-8 text-[11px]',
      size === 'md' && 'h-10 w-10 text-xs',
      size === 'lg' && 'h-12 w-12 text-sm',
      className
    )}
  >
    {initials}
  </span>
);

export const Glow = ({ className }) => (
  <div aria-hidden="true" className={clsx('pointer-events-none absolute rounded-full blur-3xl', className)} />
);
